module.exports = __webpack_public_path__ + "static/media/bold.39af8e0c.svg";